import React, { useState } from 'react';

const ContactSection = () => {
  const [emailCopied, setEmailCopied] = useState(false);
  const email = "agarwalvivek92@gmail.com";

  const copyEmail = () => {
    navigator.clipboard.writeText(email);
    setEmailCopied(true);
    setTimeout(() => setEmailCopied(false), 2000);
  };

  return (
    <section id="contact" className="py-20 px-4 bg-gray-100">
      <div className="w-full lg:max-w-5xl lg:mx-auto text-center mb-24">
        <h2 className="text-4xl lg:text-6xl font-bold mb-8">get in touch</h2>
        
        <h3 className="text-5xl lg:text-6xl font-light mt-32 mb-8 text-primary">Vivek Agarwal</h3>
        
        <p className="text-xl font-lightlg:text-2xl leading-relaxed mb-12 text-base-content/80 max-w-4xl mx-auto">
          Are you a product based startup or company? I always welcome new opportunities to exchange ideas and to explore collaborations.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <button 
            onClick={copyEmail}
            className="btn btn-primary btn-lg px-8 py-4 gap-3 relative"
            onMouseEnter={() => setEmailCopied(false)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.44c.5.28 1.12.28 1.62 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
            {emailCopied ? 'Email Copied!' : 'Email'}
          </button>
          
          <a 
            href="https://linkedin.com/in/agarwalvivek92" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-outline btn-lg px-8 py-4 gap-3"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
            LinkedIn
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 